module.exports = __webpack_public_path__ + "static/cocalex-d66c7cd26f9e07c3167e7e2c8e8aca6d.png";